export default {
  container: {
    cursor: 'pointer',
    padding: '24px 24px 54px 8px',
    margin: '10px',
    maxWidth: '490px',
    width: '100%',
    height: '68px',
    textDecoration: 'none',
    flexDirection: 'column',
    alignItems: 'left',
  },
};
